import { trpc } from "lib/trpc";

export const useCreateConversation = (userId: string) => {
    const createOrGetConversation = trpc.messages.createOrGetConversation.useMutation();

    const createConversation = async () => {
        try {
            const data = await createOrGetConversation.mutateAsync({ userId });
            const conversationId = (data as { id: string }).id;

            return conversationId;
        } catch (error) {
            console.error("Failed to create/get conversation:", error);
            throw error;
        }
    };

    return createConversation;
};
